import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ROLE_HK_USER } from '../shared/constants';
import { DeclarationsAuthService } from './declarations-auth.service';
import { map, Observable, skipWhile } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HkUserGuard {
  constructor(
    private authService: DeclarationsAuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    return this.authService.hasRole$(ROLE_HK_USER).pipe(
      skipWhile((hasRole) => !hasRole), // Wait until we get a true value
      map((hasRole) => {
        if (hasRole) {
          return true;
        } else {
          this.router.navigate(['/']);
          return false;
        }
      })
    );
  }
}
